import React from 'react'
import MotifMenuItem from '../../MenuItem'
import { Motif2RenameWarning } from '../../../utils/internal'

export default function MenuItem(props) {
  Motif2RenameWarning('Menu/Item', 'MenuItem')

  return <MotifMenuItem {...props} />
}
